<template>
  <div class="bg-gray">
    <div class="form-content">
      <el-form
          :model="formData"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="汇款时间" prop="pay_off_date"
              :rules="[{ required: true, message: '请输入汇款时间' }]"
            >
              <el-input
                  type="text"
                  placeholder="请输入汇款时间"
                  v-model="formData.pay_off_date"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="汇款单号" prop="pay_off_id"
              :rules="[{ required: true, message: '请输入汇款单号' }]"
            >
              <el-input
                  type="text"
                  placeholder="请输入汇款单号"
                  v-model="formData.pay_off_id"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="线下支付凭证">
              <PicUploader :fileList="formData.order_pics" :limit="1"></PicUploader>
              <div class="form-label-desc">上传支付凭证</div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col class="footer-button">
            <el-button type="primary" @click="submitForm('ruleForm')" :loading="saveLoading">确定提交
            </el-button>
            <!--            <el-button @click="resetForm('ruleForm')" plain>重置</el-button>-->
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<style scoped>
</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';
    import FileUploader from '@/components/picker/FileUploader.vue';

    import {
      Cell,
      Field,
      Area,
      Form,
      Divider,
      CellGroup,
      RadioGroup,
      Radio,
      ActionSheet,
      Icon,
      Toast,
      Popup,
      Picker,
      Sidebar,
      SidebarItem,
      Tag,
      Stepper,
      Switch,
      Button,
      Dialog
    } from 'vant';
    import CaipanPicker from '@/components/picker/CaipanPicker.vue';
    import FamliyPicker from '@/components/picker/FamliyPicker.vue';

    import PayDialog from '@/components/PayDialog.vue';

    Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(ActionSheet).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button);
    export default {
        name: 'SaiApplyBeizhu',
        components: {
            [Field.name]: Field,
            PicUploader,
            PayDialog,
            FileUploader,
        },
        data: function () {
            return {
                validator,
                payDialogShow:false,
                saveLoading:false,
                showArea:false,
                areaList:{},
                areaValue:'',
                submitType:'',
                subjectName:'',
                orderIds:[],
                subjectArray:[],
                subjectOptions:[],
                row:{
                    order:{

                    }
                },
                formData:{

                }
            }
        },
        filters: {},
        mounted() {
            let that = this;
            that.row.id = this.$route.query.id;
            if(that.row.id){
                this.fetch();
            }
        },
        watch: {
            formData() {
            }
        },
        destroyed() {
        },
        methods: {
            onQuestion(){
                console.log('onQuestion')
            },

          submitForm(formName) {
            const that = this;
            // 拿到地区的 省市区名称
            // that.formData["area"] = that.formData.areas[2];
            if (!that.formData.order_pics.length) { 
                that.$message.error('请上传支付凭证');
              return;
            }

            console.log(that.formData, that.$refs[formName])
            that.$refs[formName].validate((valid) => {
              if (valid) {
                that.$api.post('/api/isai/beizhusave',{
                  id : that.formData.id,
                  order_pics: that.formData.order_pics,
                  pay_off_id: that.formData.pay_off_id,
                  pay_off_date: that.formData.pay_off_date, 
                },(res) => {
                  that.saveLoading = false;

                  that.$message.success('保存成功');

                  setTimeout(function () {
                    rbLink({
                      name:'ISaiApplyDetail',
                      query:{
                        id: that.row.id
                      }
                    },'back')
                  },100);

                }, (res) => {
                  that.$message.error(res.msg);
                  that.saveLoading = false;
                })
              } else {
                console.log("error submit!!");
                return false;
              }
            });
          },
          resetForm(formName) {
            this.$refs[formName].resetFields();
          },
            onSubmit(values){
                console.log('onSubmit-values',values);
                console.log('submitType',this.submitType);

                let that = this;
                console.log(that.formData)
                that.formValidate = true;
                for (let field in that.formData) {

                }
                that.saveLoading = true;

                that.$api.post('/api/isai/beizhusave',{
                    id : that.formData.id,
                    order_pics : that.formData.order_pics,
                },(res) => {
                    that.saveLoading = false;

                    Toast('保存成功');

                    setTimeout(function () {
                        rbLink({
                            name:'ISaiApplyDetail',
                            query:{
                                id: that.row.id
                            }
                        },'back')
                    },100);

                }, (res) => {
                    Toast.fail(res.msg);
                    that.saveLoading = false;
                })
            },
            save(values){
                this.submitType = 'save';
            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            submit(values) {
                this.submitType = 'submit';
            },
            fetch(){
                let that = this;
                that.$api.post('/api/isai/beizhudetail', {
                    id:that.row.id
                }, (res) => {
                    that.formData = res.data;
                }, (res) => {
                    Toast.fail(res.msg);
                })
            },



        }
    }
</script>



// WEBPACK FOOTER //
// SaiApplyBeizhu.vue?28dc9e50